export default __webpack_public_path__ + "static/media/linkdin.22b1fa8c.svg";